module.exports = __webpack_public_path__ + "img/outlook-signature-name.ddaf824b.png";